<template>
	<modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal"
		:modal-scroll="false">
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
				:method="selectedUrl ? 'put' : 'post'" :data-url="selectedUrl
					? `${API_VOUCHER_CATEGORY}/${inputs.id}`
					: `${API_VOUCHER_CATEGORY}`
					">

				<!-- Voucher Category code -->
				<div class="form-group row align-items-center">
					<label for="inputs_form_voucher_category_code" class="col-sm-3 mb-0">
						{{ $t("form_voucher_category_code") }}
					</label>
					<app-input id="inputs_form_voucher_category_code" class="col-sm-9" type="text" v-model="inputs.code"
						:placeholder="$t('form_voucher_category_code')" :read-only="inputs?.id ? inputs.id > 0 : false"
						:required="true" :min-length="2" />
				</div>
				<!-- Voucher Category code -->

				<!-- Voucher Category description -->
				<div class="form-group row align-items-center">
					<label for="inputs_form_voucher_category_desc" class="col-sm-3 mb-0">
						{{ $t("form_voucher_category_desc") }}
					</label>
					<app-input id="inputs_form_voucher_category_desc" class="col-sm-9" type="text"
						v-model="inputs.description" :placeholder="$t('form_voucher_category_desc')" :required="true"
						:min-length="1" />
				</div>
				<!-- Voucher Category description -->

				<!-- Voucher Category deduction -->
				<div class="form-group row align-items-center">
					<label for="inputs_form_voucher_category_deduction" class="col-sm-3 mb-0">
						{{ $t("form_voucher_category_deduction") }}
					</label>
					<app-input id="inputs_form_voucher_category_deduction" class="col-sm-9" type="currency"
						thousand-separator="." :precision="0" v-model="inputs.deduction"
						:placeholder="$t('form_voucher_category_deduction')" :required="true" :min-number="0" />
				</div>
				<!-- Voucher Category deduction -->

			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { API_VOUCHER_CATEGORY } from "../../../../Config/ApiUrl.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: 0,
					code: '',
					description: '',
					deduction: 0,
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			API_VOUCHER_CATEGORY: API_VOUCHER_CATEGORY,
			inputs: {
				name: "",
				id: this.value?.id ?? 0,
				code: this.value?.code ?? "",
				description: this.value?.description ?? "",
				deduction: this.value?.deduction ?? 0,
			},
			modalId: this.formId,
			modalTitle: this.$t("form_voucher_category_title_create"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},
		afterSuccessFromGetEditData(response) {
			// console.log('afterSuccessFromGetEditData.res:', response);
			this.inputs = response.data;
			this.preloader = false;
		},
	},
}
</script>
